document.addEventListener('DOMContentLoaded', function () {
  var dataEl = document.getElementById('new-version-cross-sell-data');
  if (!dataEl) return;

  var url = dataEl.getAttribute('data-url');
  var price = dataEl.getAttribute('data-price');
  if (!url || !price) return;

  var banner = document.createElement('a');
  banner.href = url;
  banner.style.cssText = 'display:block;background-color:#F5F5F5;border:1px solid #DDDDDD;border-radius:6px;padding:10px 14px;margin:14px 0;text-decoration:none;font-family:Averta,sans-serif;color:#3C3C3B;font-size:14px;line-height:1.4;';
  banner.innerHTML =
    'También disponible en su versión <strong>nueva</strong> desde <strong>' + price + '</strong>. ' +
    '<span style="text-decoration:underline;">Ver producto →</span>';

  var priceBlock = document.querySelector('.modal_price');
  if (priceBlock && priceBlock.parentNode) {
    priceBlock.parentNode.insertBefore(banner, priceBlock.nextSibling);
  } else if (dataEl.parentNode) {
    dataEl.parentNode.insertBefore(banner, dataEl);
  }
});
